import apiCall from 'Services/Api'

export function refresh({ refreshToken }) {
  return apiCall({
    endpoint: '/auth/refresh-token',
    method: 'GET',
    query: { refreshToken },
  })
}
